"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var requestHelpers = __importStar(require("../../core/requestHelpers"));
var ImageService = /** @class */ (function () {
    function ImageService(axios, store) {
        this.axios = axios;
        this.store = store;
    }
    //---------------------------------------------------------------------------
    // upload
    ImageService.prototype.getSharedAccessSignature = function (fileName, sizeBytes, contentType, 
    // tags: string | null,
    // projectId: number | null,
    // bucketId: number,
    cancelToken, systemUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/GetSharedAccessSignature", {
                            fileName: fileName,
                            sizeBytes: sizeBytes,
                            contentType: contentType,
                            // tags: tags,
                            // projectId: projectId,
                            // bucketId,
                            systemUser: systemUser,
                        }, {
                            cancelToken: cancelToken.token,
                            tpsDotNet: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.verifyUploadFile = function (uploadId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/VerifyFileUploaded", { uploadId: uploadId }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.cloudImageResize = function (uploadId, lastModifiedDate, systemUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/CloudImageResize", { uploadId: uploadId, lastModifiedDate: lastModifiedDate, systemUser: systemUser }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.checkResizeStatus = function (uploadIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/CheckResizeStatus", { uploadIds: uploadIds, now: new Date().toISOString() }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.getImagesByUploadImageIds = function (uploadImageIds, systemUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/GetImagesByUploadImageIds", { uploadImageIds: uploadImageIds, systemUser: systemUser }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.reprocess = function (fileId, systemUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/Reprocess", { fileId: fileId, systemUser: systemUser }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.queueImageForResize = function (imageId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/QueueImageForResize", { imageId: imageId }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.checkImageResizeStatus = function (imageIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/CheckImageResizeStatus", { imageIds: imageIds }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    //---------------------------------------------------------------------------
    // file details view
    ImageService.prototype.getImageDetailsJson = function (imageId, shareLink) {
        if (shareLink === void 0) { shareLink = null; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/ImageDetailsJson", { imageId: imageId, shareLink: shareLink }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.getImageById = function (imageId, minimal) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/GetImageById", { imageId: imageId, minimal: minimal }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.getImageMetadata = function (imageId, shareLink) {
        if (shareLink === void 0) { shareLink = null; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/ImageMetadataJson", { imageId: imageId, shareLink: shareLink }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.getSimilarFiles = function (imageId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/SimilarImagesJson", { imageId: imageId }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ImageService.prototype.fileVersionHistory = function (projectId, fileId, shareLink) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/FileVersionHistory", { projectId: projectId, fileId: fileId, shareLink: shareLink }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // async getImageTitleById(id: number, shareLink: string) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/GetImageTitleById",
    //     {
    //       id,
    //       shareLink,
    //     },
    //   );
    // }
    // async getSharedImageById(id: number, shareLink: string) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/GetSharedImageById",
    //     {
    //       imageId: id,
    //       shareLink,
    //     },
    //   );
    // }
    // async getDefaultBrandingAndSigname() {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/GetDefaultBrandingAndSigname",
    //     {},
    //   );
    // }
    // async getOnlineReferences(offset: number, fetch: number) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/OnlineReferencesJson",
    //     { offset, fetch },
    //   );
    // }
    // async updateImage(payload: any) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/UpdateImage",
    //     payload,
    //   );
    // }
    ImageService.prototype.imagesExists = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ids || !ids.length)
                            return [2 /*return*/, { data: [] }];
                        return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/ImagesExists", { imageIds: ids }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // async deleteSelected(ids: number[]) {
    //   const data = await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/DeleteSelected",
    //     { imageIds: ids },
    //   );
    //   this.store.commit("project/setHasDeletedImages", true);
    //   return data;
    // }
    // async setImagesTag(imageIdArray: number[], tag: string) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/AddTagToImages",
    //     {
    //       imageIds: imageIdArray,
    //       tagString: tag,
    //     },
    //   );
    // }
    // async updateMultipleImages(
    //   imageIds: number[],
    //   artistId: number,
    //   brandingId: number,
    //   tags: any[],
    // ) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/UpdateMultipleImages",
    //     {
    //       imageIds,
    //       artistId,
    //       brandingId,
    //       tags,
    //     },
    //   );
    // }
    // async verifyImageInStorage(imageId: number) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/VerifyImageInStorage",
    //     {
    //       imageId: imageId,
    //     },
    //   );
    // }
    // async cancelFileUpload(uploadIds: number[]) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/CancelFileUpload",
    //     {
    //       uploadIds: uploadIds,
    //     },
    //   );
    // }
    // async restoreFiles(fileIds: number[]) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/RestoreFiles",
    //     {
    //       fileIds,
    //     },
    //   );
    // }
    // async versionFile(
    //   projectId: number | null,
    //   newFileId: number,
    //   oldFIleId: number,
    // ) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/VersionFile",
    //     {
    //       projectId,
    //       newFileId,
    //       oldFIleId,
    //     },
    //   );
    // }
    // async updateFileName(imageId: number, name: string) {
    //   return await requestHelpers.postWithCsrfTokenJson(
    //     this.axios,
    //     "/Image/UpdateFileName",
    //     {
    //       imageId,
    //       name,
    //     },
    //   );
    // }
    // async checkCanDownloadImages(queryString: string) {
    //   return await requestHelpers.postWithCsrfToken(
    //     this.axios,
    //     `/Image/CheckCanDownloadImages${queryString}`,
    //     {},
    //   );
    // }
    ImageService.prototype.refreshViewsByFilesIds = function (fileIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestHelpers.postWithCsrfTokenJson(this.axios, "/Image/RefreshViewsByFilesIds", { fileIds: fileIds }, { tpsDotNet: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ImageService;
}());
exports.default = ImageService;
//# sourceMappingURL=imageService.js.map